/* =====================================================================
   Qué pantalla es de qué módulo · COBRO-CLIP B2 (capa 3 de H-c)
   =====================================================================
   El vocabulario es el de `perfil_modulo` (migración 379) y coincide con
   `RUTAS_POR_MODULO` del backend: la puerta niega la escritura por ruta,
   y este mapa pone el cartel en la pantalla ANTES de que alguien pulse
   Guardar. `operacion` no aparece: no se apaga nunca. Una pantalla que
   no está aquí es del producto de siempre.

   PEAJE U-03 (5 oct 2026): ventas, compras, clientes y ubicaciones son
   módulos de pago (no vienen en Gratis), y con el plan inicial cerrando
   también se cierran. Claves de `nube/app/catalogo_planes.json`;
   pantallas de `ui/modulos.jsx` («Almacén» es la de ubicaciones).
   ===================================================================== */
export const MODULO_DE_PANTALLA = {
  pos: 'ventas',
  ventas: 'ventas',
  compras: 'compras',
  clientes: 'clientes',
  almacen: 'ubicaciones',
  facturas: 'facturacion',
  facturacion: 'facturacion',
  inspecciones: 'calidad',
  'planes-inspeccion': 'calidad',
  'no-conformidades': 'calidad',
  documentos: 'calidad',
  'mis-lecturas': 'calidad',
  rastrear: 'calidad',
  instrumentos: 'calidad',
  vencimientos: 'calidad',
  'paquete-evidencia': 'calidad',
  'calidad-ajustes': 'calidad',
  reclamos: 'reclamos',
  competencias: 'reclamos',
  'ventaja-dinero-en-la-mesa': 'reclamos',
  autorizaciones: 'autorizaciones',
  // EX-5 (1 oct 2026): el PUT de las reglas va por /api/autorizaciones,
  // que es lo que la puerta del módulo cierra.
  'accesos-reglas-de-autorizacion': 'autorizaciones',
  'escala-reglas-de-grupo': 'intercompania',
  'escala-mi-firma': 'autorizaciones',
  dispositivos: 'terminales',
  terminales: 'terminales',
  estacion: 'terminales',
  andon: 'terminales',
  asistente: 'asistente',
  'avisos-proactivos': 'api',
};

export function moduloDePantalla(id) {
  return MODULO_DE_PANTALLA[id] || null;
}

// Una sola lectura por sesión de pantalla, compartida entre el cartel y
// quien la pida después. Falla hacia abierto: sin respuesta, sin cartel.
let promesa = null;
let promesaDetalle = null;
export function modulosEnConsulta(api) {
  if (!promesa) {
    promesa = modulosDeLaCuenta(api).then((d) => new Set(d?.en_consulta || []));
  }
  return promesa;
}

/** La respuesta entera de `/escala/suscripcion/modulos`: cada módulo con
    `marca` (corona / diamante / null) y `plan` (nombre, precio y frases
    del catálogo) desde R-PLAN2, más el plan que rige (`plan`). Una lectura
    por sesión de pantalla. Falla hacia «nada que marcar». */
export function modulosDeLaCuenta(api) {
  if (!promesaDetalle) {
    promesaDetalle = api.get('/escala/suscripcion/modulos')
      .catch(() => ({ en_consulta: [], modulos: [], plan: null }));
  }
  return promesaDetalle;
}

export function olvidarModulosEnConsulta() {
  promesa = null;
  promesaDetalle = null;
}
